/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowUpSmall: {
  name: 'arrow_up_small';
  data: string;
} = {
  name: 'arrow_up_small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.032 10.156a.75.75 0 0 0 1.06 1.06L10.75 8.56v8.69a.75.75 0 0 0 1.5 0V8.56l2.657 2.657a.75.75 0 1 0 1.06-1.061L12.03 6.22a.75.75 0 0 0-1.06 0l-3.938 3.936Z" fill="currentColor"/></svg>`
};
